import queryFactory from "./queryFactory";
import userType from "Types/userType";

export default {
  useLogin: queryFactory<{
    user: { roles: { name: userType["role"] }[]; name: string };
  }>({
    tag: "login",
    url: "/users/login",
    opts: { cacheTime: 0 },
  }).useMutate,
  useRegister: queryFactory<userType>({
    tag: "register",
    url: "/users/register",
    opts: { cacheTime: 0 },
  }).useMutate,
  useIsLogin: queryFactory<{}>({
    url: "/islogin",
    tag: "islogin",
    opts: {
      cacheTime: 0,
    },
  }).useAll,
  useLogout: queryFactory<{}>({
    url: "/logout",
    tag: "logout",
    opts: {
      cacheTime: 0,
    },
  }).useAll,
  useChangePassword: queryFactory<{ password: string }>({
    tag: "changepassword",
    url: "/users/changepassword",
    opts: { cacheTime: 0 },
  }).useMutate,
};
